/* ZUZU scroll-reveal — adds .zz-in to elements as they enter the
   viewport for a gentle fade/rise. SPA-aware (re-scans on DOM
   changes). Fully bypassed when the user prefers reduced motion. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  // Elements worth revealing — section headers, cards, rows. Kept to
  // block-level "arrival" moments so it feels considered, not busy.
  var SEL = [
    '.section-head', '.modality', '.ei-card', '.tier', '.gift-card',
    '.principle', '.flow .step', '.md-about-grid', '.md-howto .step',
    '.rm-section', '.pillar-card', '.single-location', '.faq-item',
    '.giftcards .gift-how', '.rooms-ref', '.md-quote-inner', '.mod-spread'
  ].join(',');

  document.documentElement.classList.add('zz-anim');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('zz-in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function scan(root) {
    var nodes = (root || document).querySelectorAll(SEL);
    var vh = window.innerHeight || 800;
    // Batch every layout READ (sibling index + bounding rect) across all
    // candidate nodes BEFORE any DOM write. Interleaving a style write with
    // a rect read per node — the previous shape of this loop — forces a
    // synchronous layout flush on every single node (classic layout
    // thrashing), which shows up as "forced reflow" on page load since this
    // runs over every reveal candidate on the page.
    var plans = [];
    nodes.forEach(function (n) {
      if (n.hasAttribute('data-zzr')) return;
      var sibs = n.parentElement ? n.parentElement.children : [];
      var idx = Array.prototype.indexOf.call(sibs, n);
      var r = n.getBoundingClientRect();
      plans.push({
        n: n,
        delay: Math.min(idx, 6) * 60,
        visible: r.top < vh && r.bottom > 0,
      });
    });
    // Now apply every WRITE (attribute + style + reveal/observe).
    plans.forEach(function (p) {
      p.n.setAttribute('data-zzr', '');
      p.n.style.setProperty('--zzr-delay', p.delay + 'ms');
      if (p.visible) {
        requestAnimationFrame(function () { p.n.classList.add('zz-in'); });
      } else {
        io.observe(p.n);
      }
    });
  }

  var pending = null;
  function schedule() { clearTimeout(pending); pending = setTimeout(function () { scan(); }, 120); }

  function start() {
    scan();
    // SPA: the React app swaps screens/pages — re-scan on mutations.
    var mo = new MutationObserver(function (muts) {
      for (var k = 0; k < muts.length; k++) {
        if (muts[k].addedNodes && muts[k].addedNodes.length) { schedule(); return; }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
